import React, { useEffect, useState } from 'react';
import Service from './Service';
import OnlyForm from './OnlyForm';


import Footer from './Footer';


const Home = () => {
    return (
        <div>
            <Service />
            <OnlyForm />

            <Footer />


        </div>
    );
};

export default Home;